import { Toggle } from "carbon-components-react";

const ToggleSingleLine = (props) => (
  <div className="toggle__single-line">
    <Toggle {...props} />
  </div>
);

export default ToggleSingleLine;
